<template>
<div class="detail">
  <div class="wrapper">
    <div class="gallery-img">
       <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in galleryList" :key="index">
          <img v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="goods-description">
        <p class="goods-price">
          <span class="num-sign">￥</span>
          <span class="num">{{ goodsDetailListItem.price }}</span>
        </p>
        <div class="goods-info-box">
          <div class="goods-info-txt">
            <p>{{ goodsDetailListItem.title }}</p>
          </div>
          <div class="goods-share"></div>
        </div>
        <p class="express">
          快递：免运费
        </p>
    </div>

    <van-divider>产品描述</van-divider>

    <div class="goods-description-txt">
      {{ description }}
    </div>
    <div class="goods-detail-list">
       <img v-for="(img,index) in detailImgList" v-lazy="img" :key="index"/>
    </div>
  </div>

  <div class="footer">
    <van-goods-action>
      <van-goods-action-icon icon="shop-o" text="首页" @click="gotoHome"/>
      <van-goods-action-button
        type="warning"
        text="立即购买"
        @click="gotoApply"
      />
    </van-goods-action>
  </div>
</div>
</template>
<script>
import { Swipe, SwipeItem, Lazyload, Divider, GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant'

export default {
  name: 'Detail',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Lazyload.name]: Lazyload,
    [Divider.name]: Divider,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton
  },
  data () {
    return {
      goodsDetailListItem: {
        title: '',
        price: null
      },
      description: '',
      galleryList: [],
      detailImgList: []
    }
  },
  mounted () {
    this.getDetailGoodsList()
  },
  methods: {
    getDetailGoodsList () {
      const goodsDetailList = JSON.parse(localStorage.getItem('goodsDetailList'))
      this.goodsDetailListItem.title = goodsDetailList.itemTitle
      this.goodsDetailListItem.price = goodsDetailList.price
      this.galleryList = goodsDetailList.detailList
      this.detailImgList = goodsDetailList.detailList
      this.description = goodsDetailList.description
    },
    gotoHome () {
      this.$router.push({
        path: '/'
      })
    },
    gotoApply () {
      this.$router.push({
        path: '/apply'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.detail{
  .wrapper{
    .gallery-img{
      img{
        width: 100%;
      }
    }
    .goods-description{
      padding-top:2px;
      background-color: #ffffff;
      padding-bottom:12px;
      .goods-price{
        margin-left: 10px;
        color:#EA580F;
        .num-sign{
          font-size: 14px;
        }
        .num{
          font-size:22px;
        }
      }
      .goods-info-box{
        margin: 5px 10px 0 10px;
        .goods-info-txt{
          font-size: 14px;
          font-weight: 600;
          color: #333333;
          p{
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
      }
      .express{
        font-size: 12px;
        color:#999999;
        margin: 12px 10px 0 10px;
      }
    }
    .goods-description-txt{
      padding:15px 8px;
      font-size: 12px;
      background-color: #ffffff;
    }
    .goods-detail-list{
      img{
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
